import UnauthorisedErrorCard from 'ui-component/cards/UnauthorizedErrorCard';

// ================================|| Unauthorised ||================================ //

const Unauthorised = () => <UnauthorisedErrorCard errorMessage="Oops, you do not have permission to view this page." />;

export default Unauthorised;
